// extracted by mini-css-extract-plugin
module.exports = {"background":"Register_background__1901m","cards":"Register_cards__38eNr","item":"Register_item__r72yz"};